export class StoreLocation {
  id: number;
  brandId: number; 
  storeId: string;
  name: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  email: string;
  phone: string;
  hours: string; 
  url: string; 
}
